import React, { FC } from 'react'
import { useTheme } from 'react-jss'

import { ColorDot, Column, Row, Text } from '../../../components'
import { LightTheme } from '../../../theme'
import { concatClassNames } from '../../../utils'

import { useStyle } from './order-chat-status.styles'
import { OrderChatStatusProps } from './order-chat-status.types'

export const OrderChatStatus: FC<OrderChatStatusProps> = ({
  className,
  isStatusDraft,
  color,
  title,
  titleTx,
  titleValues,
  statusText,
  statusTx
}) => {
  const theme = useTheme<LightTheme>()
  const classes = useStyle()

  const themeColor = theme.colors[color]
  return (
    <Row
      fullWidth
      className={concatClassNames(className, classes.offerTitleContainer)}
      justifyContent="flex-start"
    >
      <ColorDot color={themeColor} preset="big" />
      <Column alignItems="flex-start" className={classes.offerTitle}>
        {!isStatusDraft && (
          <Text
            className={classes.title}
            preset="h5"
            text={title}
            tx={titleTx}
            values={titleValues}
          />
        )}
        <Text
          className={classes.offerDescription}
          preset="h7"
          text={statusText}
          tx={statusTx}
        />
      </Column>
    </Row>
  )
}
